/**
 * Extra Claude Code logins kept on this computer. Each login has its own
 * folder, which never leaves native code: the webview and the backend only
 * see the id. The default login is the CLI's own and has no entry here.
 */
import { invoke } from "@tauri-apps/api/core";

export type CliLoginCli = "claude_cli";

export interface CliLogin {
  id: string;
  cli: CliLoginCli;
  name: string;
  created_at: string;
}

export interface CliLoginStatus {
  logged_in: boolean;
  /** `false` when the saved credentials were rejected; `null` when unchecked. */
  auth_verified: boolean | null;
  /** The signed-in account, as `claude auth status` names it; `null` while signed out. */
  email: string | null;
  org_name: string | null;
  /** E.g. "pro", "max", "team". */
  subscription_type: string | null;
}

export function listCliLogins(): Promise<CliLogin[]> {
  return invoke("cli_logins_list");
}

export function addCliLogin(cli: CliLoginCli, name: string): Promise<CliLogin> {
  return invoke("cli_login_add", { cli, name });
}

export function renameCliLogin(id: string, name: string): Promise<CliLogin> {
  return invoke("cli_login_rename", { id, name });
}

/** Signs the login out and deletes its folder. */
export function removeCliLogin(id: string): Promise<void> {
  return invoke("cli_login_remove", { id });
}

/** `id: null` checks the default login. */
export function getCliLoginStatus(id: string | null): Promise<CliLoginStatus> {
  return invoke("cli_login_status", { id });
}

/** Signed in, and the saved credentials were not rejected. */
export function isCliLoginSignedIn(status: CliLoginStatus): boolean {
  return status.logged_in && status.auth_verified !== false;
}
